import React from 'react';
import {
    IconButton,
    Modal,
    //Grow,
    useMediaQuery,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';


import ContainerFrame from "./frame";
import { SizeClassProvider } from "../muiMediaQuery";

import './container.css';


const ButtonContainer = ( props ) => {
    if( !props.buttons && !props.onCloseButton )
        return (null);

    return(<div className="container-buttons">
            { props.buttons }
            { props.onCloseButton && <IconButton aria-label="close" size="small" onClick={props.onCloseButton}>
                <CloseIcon />
            </IconButton> }
        </div>);
}

const Renderer = React.forwardRef( (props, ref)=>{
    let cssClass = "floating"
    if( props.className )
        cssClass += " " + props.className;

    if( props.position ) {
        cssClass += " pos-"+props.position;
    }
    if( props.heightFixed ) {
        cssClass += " fixed-height";
    }

    // execute the breakpoint
    const matchesFS = useMediaQuery(theme => theme.breakpoints.down(props.fsSwitch));
    let isfullscreen = false;
    if( props.fsSwitch ) {
        if( matchesFS ) {
            cssClass += " bp-fullscreen-" + props.fsSwitch;
            isfullscreen = true;
        }
    }
    let width = null;
    if( !isfullscreen ) {
        width = props.width;
    }
    if( props.largeBottomPadding === true ) {
            cssClass += " largeBottomPadding";
    }

    return (<SizeClassProvider>
                <ContainerFrame ref={props.ref} className={cssClass}
                        style={props.style}
                        width={width}
                        square={matchesFS}
                    >
                    <ButtonContainer buttons={props.buttons} onCloseButton={props.onCloseButton} />
                    { props.children }
                </ContainerFrame>
        </SizeClassProvider>);
});

/**
 * ---------------------------------------------------------------------
 * FloatingContainer
 * ---------------------------------------------------------------------
 * stateless function component
 *
 * container with frame which "hovers/floats" somewhere inside our views
 * has optional Modal.
 *
 * @see https://material-ui.com/components/modal/
 *
 * @see frame.js for additional props
 *
 * @prop [string]   position      [optional] [ center, dock-left, dock-right, dock-top or dock-botton ]
 * @prop [bool]     heightFixed   [optional]
 * @prop [string]   fsSwitch      [optional] [xs, sm, md, lg or xl ]
 *                                defines the full screen switch breakbpoint
 *                                below that value the container becomes fitting full screen
 *
 * @prop [bool]     modal         [optional] default false
 * @prop [func]     onClickAway   [optional] if useClickAway is used the is mandatory.
 *
 * @prop [node]     children
 * @prop [string]   className
 * @prop [string]   style
 */
const FloatingContainer = (props) => {
/*        const [open, setOpen] = React.useState(false);

        const doClose = () => {
            setOpen(false);
        };*/
        // Grow

        if( props.modal ) {
            return (<Modal className="floating-modal"
                            open={true}
                            hideBackdrop={ props.hideBackdrop }
                            onClose={props.onClickAway}
                            disablePortal={false}
                        >
                        <Renderer {...props} />
                </Modal>);
        }

        return (<Renderer {...props} />)
}
/*
* ---------------------------------------------------------------------
* Export
* ---------------------------------------------------------------------
*/
export default FloatingContainer;
